import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {OneStopShopAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-one-stop-shop-angaben',
  templateUrl: './one-stop-shop-angaben.component.html'
})
export class OneStopShopAngabenComponent extends WizardPageBaseComponent<OneStopShopAngaben> {

  static nutzdatenPath = 'oneStopShopAngaben';
  static route = 'one-stop-shop-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  onInlandAnsaessigkeitsstaatChanged(e: Record<string, Record<string, unknown>>): void {
    if (e.target.checked === false) {
      this.data.inlandKeineNiederlassungEU = false;
      this.onInlandKeineNiederlassungEUChanged(e);
    }
  }

  onInlandKeineNiederlassungEUChanged(e: Record<string, Record<string, unknown>>): void {
    if (e.target.checked === false) {
      this.data.inlandInlandversteuerung = false;
      this.data.inlandInlandversteuerungVerzicht = false;
      this.onInlandInlandversteuerungVerzichtChanged(e);
    }
  }

  onInlandInlandversteuerungVerzichtChanged(e: Record<string, Record<string, unknown>>): void {
    if (e.target.checked === false) {
      this.data.inlandInlandversteuerungVerzichtBZSt = false;
      this.data.inlandInlandversteuerungVerzichtEU = false;
    }
  }

  onAuslandAnsaessigkeitsstaatChanged(e: Record<string, Record<string, unknown>>): void {
    if (e.target.checked === false) {
      this.data.auslandNiederlassungEU = false;
      this.onAuslandNiederlassungEUChanged(e);
    }
  }

  onAuslandNiederlassungEUChanged(e: Record<string, Record<string, unknown>>): void {
    if (e.target.checked === false) {
      this.data.auslandNiederlassungEUAnsaessigkeitstaatversteuerung = false;
      this.data.auslandNiederlassungEUVerzicht = false;
      this.onAuslandNiederlassungEUVerzicht(e);
    }
  }

  onAuslandNiederlassungEUVerzicht(e: Record<string, Record<string, unknown>>): void {
    if (e.target.checked === false) {
      this.data.auslandNiederlassungEUVerzichtErklaerungAnsaessigkeitstaat = false;
      this.data.auslandNiederlassungEUVerzichtErklaerungDeutschland = false;
    }
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
